'use strict';

angular.module('uniromaLandingApp')
    .controller('ConfigParamDetailController', 
    		['$scope', '$rootScope', '$stateParams', 'entity', 'ConfigParam',function ($scope, $rootScope, $stateParams, entity, ConfigParam) {
        $scope.configParam = entity;
        $scope.load = function (id) {
            ConfigParam.get({id: id}, function(result) {
                $scope.configParam = result;
            });
        };
        $rootScope.$on('uniromaLandingApp:configParamUpdate', function(event, result) {
            $scope.configParam = result;
        });
    }]);
